/**
 * Traveller specific to Synchronyme :
 *
 * got journey or booking info to display
 *
 * herited form traveller component
 */
import { SynchronymeService } from "../../../app_synchronyme/service/synchronyme/synchronyme.service";

import { Yii } from "libraries/interfaces/Yii";
import _set from 'lodash-es/set';
import _isObject from 'lodash-es/isObject';
import _values from 'lodash-es/values';
import _toString from 'lodash-es/toString';
import _find from 'lodash-es/find';

declare var wenji: any;

// Core modules
import { Component, OnInit } from '@angular/core';

import { TravellerComponent } from '../traveller/traveller.component';
import { INameList } from "../../../app_synchronyme/service/synchronyme/INameList.interface";

//libs
import { faEye, faEyeSlash, faUserTimes, faExclamation, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({

    selector: 'traveller-synchronyme',
    templateUrl: 'travellersynchronyme.component.html'
})

export class TravellerSynchronymeComponent extends TravellerComponent implements OnInit {
    // showDetails = false;
    public showMessage = false;
    public isShowingDetails = false;
    public wenji = wenji;
    public varTest: any = {
        var1: true,
        var2: true
    };

    public t_title = {
        Mr: Yii.t('wui-shared-js', 'M.'),
        Mrs: Yii.t('wui-shared-js', 'Mme'),
        Ms: Yii.t('wui-shared-js', 'Mme')
    };

    public nameListsConfig: INameList[];
    public isDetails: boolean = false;
    public pop: boolean;

    public iconEye: IconDefinition = faEye;

    public iconEyeSlash: IconDefinition = faEyeSlash;

    public iconExclamation: IconDefinition = faExclamation;

    public iconUserTimes: IconDefinition = faUserTimes;

    constructor(private readonly synchronymeService: SynchronymeService) { super(); }

    public ngOnInit() {
        this.synchronymeService.getNamelists()
            .subscribe((nameLists) => {
                this.nameListsConfig = nameLists;
            });
    }
    public getExportName(host: string): string {
        const exportName = _find(this.nameListsConfig, (nl: INameList) => nl.host === host);
        if (exportName) {
            return exportName.wording.short;
        } else {
            return Yii.t('wui-shared-js', 'Export');
        }
    }

    /**
     * returns journey type (pnr, namelist)
     * @returns {string}
     */
    public getJourneyType(): string {

        let output: string = "";

        if (this.travellerItem.journey.booking && this.travellerItem.journey.booking.type) {
            output = this.travellerItem.journey.booking.type;
        }

        return output;
    }

    /**
     * getJourneyValue
     * @returns {string} : return journey code
     */
    public getJourneyValue(): string {
        let output: string;

        const journey = this.travellerItem.journey;
        if (this.getJourneyType() === "PNR") {
            if (_isObject(journey.booking.code)) {
                output = _values(journey.booking.code)[0];
            } else {
                output = journey.booking.code;
            }
        } else if (this.getJourneyType() === "NAMELIST" || this.getJourneyType() === "MIDOFFICE") {
            output = journey.booking.host;
        }

        return output;
    }

    /**
     * showPnr
     * event emited when click on Pnr reference
     *
     * @param {string} _nameListType
     * @param {string} _nameListId
     */
    public showPnr(_nameListType: string, _nameListId: string,) {
        const event = { 'type': _nameListType, 'id': _nameListId };
        this.showPnrEvent.emit(JSON.stringify(event));
    }

    /**
     * getJourneyId
     *
     * @returns {string | number} : journey Id
     */
    public getJourneyId(): string | number {
        let output: string;

        const journey = this.travellerItem.journey;

        if (this.getJourneyType() === "NAMELIST" || this.getJourneyType() === "MIDOFFICE" ) {
            output = journey.id;
        }

        return _toString(output);

    }

    /**
     * getBookingType
     *
     * @returns {string}
     * TODO : admin?
     */
    public getBookingType(): string {
        let output: string;

        output = Yii.t('wui-shared-js', 'Dossier');

        return output;
    }

    /**
     * getBookingValue
     *
     * @returns {string} : returns booking Code
     */
    public getBookingValue(): string {
        let output: string;

        if (_isObject(this.travellerItem.booking.code)) {
            output = _values(this.travellerItem.booking.code)[0];
        } else {
            output = this.travellerItem.booking.code;
        }

        return output;
    }

    /**
     * removeMe
     * event launched when removing the item
     */
    public removeMe() {
        this.removePax.emit(this.travellerItem.id);
    }

    /**
     * showTnr
     * event emited when click on Tnr reference
     *
     * @param {string} _nameListType
     * @param {string} _nameListId
     */
    public showTnr(_nameListType: string, _nameListId: string) {
        const event = { 'type': _nameListType, 'id': _nameListId };
        this.showTnrEvent.emit(JSON.stringify(event));
    }

    /**
     * isJourneyError
     * @returns {boolean}: true if no booking value
     */
    public isJourneyError(): boolean {
        let output = false;
        const journey = this.travellerItem.journey;
        if (journey.id && !journey.booking) {
            output = true;
        }
        return output;
    }
    /**
     * shDetails
     * used to show details on click
     */
    public shDetails(): void {
        // this.showDetails = !this.showDetails;
        this.showMessage = !this.showMessage;
        this.isShowingDetails = !this.isShowingDetails;
        if (this.showDetails) {
            this.showDetails = false;
        } else {
            this.showDetails = true;

        }
        _set(this.varTest, 'var1', false);
    }

    /**
     * showNamelist
     * event emited when click on Tigre reference
     *
     * @param {string} _nameListType
     * @param {string} _host
     * @param {string | number} _id
     */
    public showNamelist(_nameListType: string, _host: string, _id: string | number) {
        const event = { 'type': _nameListType, 'host': _host, 'id': _id };
        this.showPnrEvent.emit(JSON.stringify(event));
    }
}
